// extracted by mini-css-extract-plugin
export var text = "_9k-0";